export const ACTIVE_AUTH_KEY = "activeAuthIdentity";

const AUTH_STORAGE_KEYS = [
  ACTIVE_AUTH_KEY,
  "user",
  "userRole",
  "professorId",
  "professorCourseId",
  "studentId",
  "lastActivity",
];

export function clearActiveAuth() {
  AUTH_STORAGE_KEYS.forEach((key) => localStorage.removeItem(key));
}

export function setActiveAuth(identity) {
  clearActiveAuth();
  localStorage.setItem(ACTIVE_AUTH_KEY, JSON.stringify(identity));

  if (identity.accountType === "admin") {
    localStorage.setItem("user", JSON.stringify(identity));
    localStorage.setItem("userRole", identity.role);
    localStorage.setItem("lastActivity", Date.now().toString());
  } else if (identity.accountType === "professor") {
    localStorage.setItem("professorId", String(identity.id));
    if (identity.courseId) localStorage.setItem("professorCourseId", String(identity.courseId));
  } else if (identity.accountType === "student") {
    localStorage.setItem("studentId", String(identity.id));
  }
}

export function getActiveAuth() {
  try {
    const stored = JSON.parse(localStorage.getItem(ACTIVE_AUTH_KEY) || "null");
    if (stored?.id && ["admin", "professor", "student"].includes(stored.accountType)) {
      return stored;
    }
  } catch (_) {
    // Fall through to legacy state for sessions created before this change.
  }

  try {
    const user = JSON.parse(localStorage.getItem("user") || "null");
    if (user?.id && localStorage.getItem("userRole")) {
      return { ...user, accountType: "admin", role: localStorage.getItem("userRole") };
    }
  } catch (_) {
    // Invalid legacy admin state is treated as unauthenticated.
  }

  const professorId = localStorage.getItem("professorId");
  if (professorId) return { id: professorId, accountType: "professor", role: "professor" };
  const studentId = localStorage.getItem("studentId");
  if (studentId) return { id: studentId, accountType: "student", role: "student" };
  return null;
}

